import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubmitField } from '../../hooks/useSubmitField';
import { SubmitFormContext } from '../../context';
import { MAX_TITLE_LENGTH } from '../../constants';
import { validator } from './validation';

const TitleField: React.FC<{ noBottomSpacing?: boolean }> = ({ noBottomSpacing }) => {
  const { t } = useTranslation();
  const {
    params: { isPresetsForm },
  } = useContext(SubmitFormContext)!;
  const {
    id,
    error,
    field: { ref, ...inputProps },
  } = useSubmitField('title', {
    initAdapter: ({ deviation }) => String(deviation?.title ?? '').substring(0, MAX_TITLE_LENGTH),
    submitAdapter: ({ title }) => ({ title }),
    validator,
  });
  const isMobile = useContext(MobileContext);

  return (
    <TextInput
      id={id}
      details={error?.message}
      validationResult={error ? 'error' : undefined}
      maxLength={MAX_TITLE_LENGTH}
      ref={ref}
      label={t('deviationSubmit.form.title.label')}
      placeholder={t('deviationSubmit.form.title.placeholder')}
      isRequired={!isPresetsForm}
      autoFocus={!isMobile}
      noBottomSpacing={noBottomSpacing}
      {...inputProps}
    />
  );
};
TitleField.displayName = 'TitleField';

export default TitleField;
